<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25.029">
    <g transform="translate(-18.268 -0.971)">
      <g transform="translate(18.268)">
        <path
          d="M114.832,10.406a5.013,5.013,0,0,0,3.679-1.524A5.013,5.013,0,0,0,120.035,5.2a5.014,5.014,0,0,0-1.524-3.679,5.2,5.2,0,0,0-7.358,0A5.013,5.013,0,0,0,109.629,5.2a5.013,5.013,0,0,0,1.524,3.679A5.013,5.013,0,0,0,114.832,10.406Z"
          transform="translate(-102.495 0.971)"
          fill="currentColor"
          opacity="0.6"
        />
        <path
          d="M42.208,209.083a17.831,17.831,0,0,0-.239-1.879,14.748,14.748,0,0,0-.452-1.87,8.919,8.919,0,0,0-.733-1.68,6.046,6.046,0,0,0-1.057-1.4,4.443,4.443,0,0,0-1.457-.922,5.074,5.074,0,0,0-1.9-.345,2.074,2.074,0,0,0-.716.371q-.562.371-1.27.827a8.02,8.02,0,0,1-1.841.827,7.171,7.171,0,0,1-4.551,0,8.018,8.018,0,0,1-1.841-.827q-.707-.457-1.27-.827a2.074,2.074,0,0,0-.716-.371,5.071,5.071,0,0,0-1.9.345,4.442,4.442,0,0,0-1.457.922,6.053,6.053,0,0,0-1.057,1.4,8.932,8.932,0,0,0-.733,1.68,14.749,14.749,0,0,0-.452,1.87,17.726,17.726,0,0,0-.239,1.879q-.06.871-.06,1.784a4.321,4.321,0,0,0,1.244,3.266,4.569,4.569,0,0,0,3.307,1.2h14.9a4.569,4.569,0,0,0,3.307-1.2,4.319,4.319,0,0,0,1.244-3.266Q42.268,209.954,42.208,209.083Z"
          transform="translate(-18.268 -189.33)"
          fill="currentColor"
        />
        <g transform="translate(10.337 4.174)">
          <line
            y2="5.657"
            transform="translate(0 0) rotate(-45)"
            fill="none"
            stroke="#fff"
            stroke-width="1"
          />
          <line
            y2="5.657"
            transform="translate(4 0) rotate(45)"
            fill="none"
            stroke="#fff"
            stroke-width="1"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
